<template>
  <b-form @submit.prevent="submit">
    <header-page-layout page-title="Login">
      <b-row class="justify-content-center">
        <b-col col lg="4">
          <b-card>
            <b-alert v-if="authError" variant="danger" show>Email or password are incorrect</b-alert>

            <b-form-group label="Email Address">
              <b-form-input
                type="email"
                placeholder="name@youremail.com"
                required
                v-model="email"
              ></b-form-input>
            </b-form-group>

            <b-form-group label="Password">
              <b-form-input
                type="password"
                required
                placeholder="password"
                v-model="password"
              ></b-form-input>
            </b-form-group>

            <b-button type="submit" variant="primary">Login</b-button>
          </b-card>
        </b-col>
      </b-row>
    </header-page-layout>
  </b-form>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import HeaderPageLayout from '../components/HeaderPageLayout'

export default {
  mounted() {
    if (this.userToken) {
      this.$router.push({ name: 'campaigns-index' })
    }
  },

  components: {
    HeaderPageLayout
  },

  data() {
    return {
      email: '',
      password: '',
      authError: false
    }
  },

  computed: {
    ...mapState([
      'redirect',
      'userToken'
    ])
  },

  methods: {
    ...mapActions([
      'login'
    ]),

    submit() {
      this.authError = false

      this.login({
        email: this.email,
        password: this.password
      })
        .then(() => {
          this.$router.push({ path: this.redirect })
        })
        .catch(() => {
          this.authError = true
        })
    }
  }
}
</script>

<style scoped>
</style>
